import React from "react";
import { FunctionField, ShowProps } from "react-admin";
import { Chip, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const Summary = (props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Dry Run Schedule Detail
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Dry Run Date">
            <CustomDateField source="date" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <FunctionField
            render={(record: any) => (
              <CustomLabeled name="Bus Schedules">
                {record.busSchedules && record.busSchedules.length > 0 ? (
                  <div>
                    {record.busSchedules.map(
                      (busSchedule: IBusSchedule, index: number) => (
                        <span key={busSchedule.id}>
                          <Chip label={busSchedule.name} />
                          {index < record.busSchedules.length - 1 && " "}
                        </span>
                      ),
                    )}
                  </div>
                ) : (
                  <Typography>-</Typography>
                )}
              </CustomLabeled>
            )}
          />
        </Grid>
        <Grid item xs={9}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
